export default {"src":"/_next/static/media/JPMorgan.b3602525.svg","height":31,"width":106,"blurWidth":0,"blurHeight":0};